import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-145083564-1',
  checkDuplicatedScript: true,
  // 根据路由地址跟踪页面
  router,
  debug: {
    // 开发时关闭跟踪
    sendHitTask: process.env.NODE_ENV === 'production'
  },
  autoTracking: {
    // 页面加载完成前不跟踪
    pageviewOnLoad: false,
    // 屏幕属性跟踪
    // screenview: true,
  },
})

Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {//判断是否有标题
    document.title = to.meta.title
  }
  next()
})

// 跳转页面回到顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})